// eslint-disable-next-line vue-component-file-name-match/match-component-import-name
import KaMultiStepFormBase from './KaMultiStepForm.vue';
import KaMultiStepFormButtonGroup from './KaMultiStepFormButtonGroup.vue';
import KaMultiStepFormJumpToFirstButton from './KaMultiStepFormJumpToFirstButton.vue';
import KaMultiStepFormJumpToLastButton from './KaMultiStepFormJumpToLastButton.vue';
import KaMultiStepFormNextButton from './KaMultiStepFormNextButton.vue';
import KaMultiStepFormPrevButton from './KaMultiStepFormPrevButton.vue';
import KaMultiStepFormStep from './KaMultiStepFormStep.vue';

export type { Step } from './model';

Object.assign(KaMultiStepFormBase, {
  ButtonGroup: KaMultiStepFormButtonGroup,
  NextButton: KaMultiStepFormNextButton,
  PrevButton: KaMultiStepFormPrevButton,
  Step: KaMultiStepFormStep,
  JumpToFirst: KaMultiStepFormJumpToFirstButton,
  JumpToLast: KaMultiStepFormJumpToLastButton,
});

export const KaMultiStepForm = KaMultiStepFormBase as typeof KaMultiStepFormBase & {
  ButtonGroup: typeof KaMultiStepFormButtonGroup;
  NextButton: typeof KaMultiStepFormNextButton;
  PrevButton: typeof KaMultiStepFormPrevButton;
  Step: typeof KaMultiStepFormStep;
  JumpToFirst: typeof KaMultiStepFormJumpToFirstButton;
  JumpToLast: typeof KaMultiStepFormJumpToLastButton;
};

export {
  KaMultiStepFormButtonGroup,
  KaMultiStepFormJumpToFirstButton,
  KaMultiStepFormJumpToLastButton,
  KaMultiStepFormNextButton,
  KaMultiStepFormPrevButton,
  KaMultiStepFormStep,
};
